<template>
	<div class="user-container">
		<div class="avatar-container">
			<img
				v-if="avatar"
				:src="avatar"
			/>
			<span v-if="!avatar">
				<IconSvg name="selfie" />
			</span>
		</div>

		<div :class="{ dropdown }">
			<div v-if="$store.getters['user/canManage']">
				<span class="tag size-s uppercase bold green color-black">
					<IconSvg name="star" />
					A11 {{ $store.getters['user/isAdmin'] ? 'Admin' : 'Manager' }}
				</span>
			</div>
			<strong>
				{{ $store.state.user.me.local.firstName }}
				{{ $store.state.user.me.local.lastName }} </strong
			><br />
			{{ $store.state.user.me.local.email }}<br />
			<div v-if="$store.getters['account/hasAny']">
				<HorizontalRule />
				<router-link :to="{ name: 'user' }"> User Settings </router-link>
			</div>
			<HorizontalRule />
			<a @click="$store.dispatch('user/logout')">Sign Out</a>
		</div>
	</div>
</template>
<script lang="ts">
import Vue from 'vue'

import IconSvg from '@cv/components/atoms/IconSvg.vue'
import HorizontalRule from '@cv/components/atoms/HorizontalRule.vue'

export default Vue.extend({
	components: { IconSvg, HorizontalRule },
	props: {
		dropdown: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		avatar() {
			return this.$store.state.user.me.local.avatar
		},
		initials() {
			return this.$store.getters['user/initials']
		},
		fullName() {
			return this.$store.getters['user/fullName']
		}
	}
})
</script>
<style lang="less" scoped>
@import '../../less/variables';

.user-container {
	display: flex;
	position: relative;
	flex-direction: column;
	color: @grayMedium;
}

.avatar-container {
	display: inline-block;
	float: left;
	background: @grayLight;
	height: 35px;
	width: 35px;
	line-height: 35px;
	text-align: center;
	border-radius: 50%;
	font-weight: 600;
	overflow: hidden;
	img {
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
}

.user-name {
	color: @grayMedium;
	margin-left: 0.5em;
}

.horizontal-rule {
	margin: 0.5em 0;
}
</style>
